import { createContext, useContext } from 'react';
import type { ThreadSibling } from '../outreach/ThreadStepper';

/**
 * The outreach rows of the task list a `TaskCard` sits in, in that list's on-screen order — what the
 * thread dialog's Previous / Next steps through (`OutreachThreadModal` `siblings`). Provided by the list
 * (`TasksBody`), because a card cannot see its neighbours and a fold (`TaskOriginGroup`) renders cards too.
 * Absent → the dialog opens with no stepper.
 */
const OutreachSiblingsContext = createContext<readonly ThreadSibling[] | undefined>(undefined);

export const OutreachSiblingsProvider = OutreachSiblingsContext.Provider;

export function useOutreachSiblings(): readonly ThreadSibling[] | undefined {
  return useContext(OutreachSiblingsContext);
}
